import { createActionGroup, props } from '@ngrx/store';
import { CustomFilterDef } from '@src/suite/common/data-models/navigation/custom-filter-def';
import { FilterDef } from '@src/suite/common/data-models/navigation/filter-def';
import { GroupSecurityPrivs } from '@src/suite/common/data-models/service/group-security-privs';
import { MosDevice } from '@src/suite/common/data-models/service/mos-device';
import { DiscoverProviderResponse, DiscoverWireCategoryResponse } from '@src/suite/discover/store/models/feed.provider.models';

import { GlobalTablesGroupSort } from './global-tables.models';

export const GlobalTablesActions = createActionGroup({
    source: 'Global Tables',
    events: {
        'Process Global Fields': props<{ fields: { [id: string]: FieldDef } }>(),
        'Set Global Fields': props<{ fields: { [id: string]: FieldDef }; groupSortDefs: GlobalTablesGroupSort }>(),
        'Set User Location Privileges': props<{ securityPrivileges: { [id: string]: GroupSecurityPrivs } }>(),
        'Set Pst Group Id': props<{ PSTGroupId: string }>(),
        'Set Custom Filter Defs': props<{ customFilterDefs: CustomFilterDef[]; customFilterDefsDict: { [id: string]: CustomFilterDef } }>(),
        'Set Time Zone Settings': props<{ personalTimeZone: TimeZone; personalTimeZoneDisplay: TimeZone; clientTimeZone: TimeZone; defaultTimeZone: TimeZone }>(),
        'Update Time Zone Settings': props<{ personalTimeZone: TimeZone; personalTimeZoneDisplay: TimeZone }>(),
        'Set Global Tables': props<{
            Security?: Array<any>;
            Apps?: Array<any>;
            Groups?: { [id: string]: Group };
            GroupsArray?: Array<Group>;
            EnterpriseGroup?: Group;
            PlaybookTeamsArray?: Array<Group>;
            DefaultPlaybookTeam?: Group;
            EnterprisePlaybookGroup?: string;
            FieldMappings?: Array<FieldMapping>;
            MOSDevices?: Array<MosDevice>;
            Privileges?: Array<any>;
            Servers?: { [id: string]: Server };
            Adorners?: { [id: string]: Adorner };
            WireCategories?: Array<DiscoverWireCategoryResponse>;
            WireProviders?: Array<DiscoverProviderResponse>;
            Languages?: Array<ENPSLanguage>;
            PersonalLanguage?: ENPSLanguage;
            CommonTimeZones?: Array<TimeZone>;
            IanaTimeZones?: Array<TimeZone>;
            FilterDefs?: { [id: number]: Array<FilterDef> };
        }>(),
    },
});
